import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    id: "about",
    class: "w-full"
};
const _hoisted_2 = { class: "mb-16 md:flex justify-between items-end" };
const _hoisted_3 = { class: "text-sm font-mono uppercase tracking-widest opacity-50 mb-4 md:mb-0" };
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-16" };
const _hoisted_5 = { class: "flex items-center gap-3 mb-8" };
const _hoisted_6 = { class: "text-lg font-bold uppercase tracking-wider" };
const _hoisted_7 = { class: "space-y-6" };
const _hoisted_8 = ["onClick", "onKeydown"];
const _hoisted_9 = { class: "flex items-center gap-2 mb-1" };
const _hoisted_10 = { class: "font-mono text-xs uppercase tracking-widest opacity-50" };
const _hoisted_11 = {
    key: 0,
    class: "px-2 py-0.5 bg-accent text-white text-xs font-bold uppercase tracking-wide"
};
const _hoisted_12 = {
    key: 1,
    class: "px-2 py-0.5 bg-green-600 text-white text-xs font-bold uppercase tracking-wide"
};
const _hoisted_13 = { class: "text-base font-bold mb-1 group-hover:text-accent transition-colors duration-300" };
const _hoisted_14 = { class: "text-sm opacity-70" };
const _hoisted_15 = {
    key: 0,
    class: "text-sm opacity-50"
};
const _hoisted_16 = { class: "mt-3 inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-accent opacity-60 group-hover:opacity-100 transition-opacity duration-300" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { class: "flex items-center gap-3 mb-8" };
const _hoisted_19 = { class: "text-lg font-bold uppercase tracking-wider" };
const _hoisted_20 = { class: "space-y-6" };
const _hoisted_21 = { class: "font-mono text-xs uppercase tracking-widest opacity-50 block mb-1" };
const _hoisted_22 = { class: "text-base font-bold mb-1" };
const _hoisted_23 = { class: "text-sm opacity-70" };
const _hoisted_24 = { class: "space-y-12" };
const _hoisted_25 = { class: "flex items-center gap-3 mb-8" };
const _hoisted_26 = { class: "text-lg font-bold uppercase tracking-wider" };
const _hoisted_27 = { class: "space-y-4" };
const _hoisted_28 = { class: "text-sm font-medium" };
const _hoisted_29 = { class: "text-xs font-mono uppercase tracking-wider opacity-50" };
const _hoisted_30 = { class: "flex items-center gap-3 mb-8" };
const _hoisted_31 = { class: "text-lg font-bold uppercase tracking-wider" };
const _hoisted_32 = { class: "flex flex-wrap gap-3" };
const _hoisted_33 = { class: "mt-16" };
const _hoisted_34 = { class: "flex items-center gap-3 mb-8" };
const _hoisted_35 = { class: "text-lg font-bold uppercase tracking-wider" };
const _hoisted_36 = { class: "flex flex-col border-t border-black/10 dark:border-white/10" };
const _hoisted_37 = { class: "md:col-span-3" };
const _hoisted_38 = { class: "font-mono text-xs uppercase tracking-widest opacity-50 block mb-1" };
const _hoisted_39 = { class: "text-lg font-bold uppercase tracking-tight" };
const _hoisted_40 = { class: "md:col-span-3" };
const _hoisted_41 = { class: "inline-block px-3 py-1 bg-gray-100 dark:bg-white/10 text-xs font-bold uppercase tracking-wide" };
const _hoisted_42 = { class: "md:col-span-6" };
const _hoisted_43 = { class: "text-sm opacity-70 leading-relaxed" };
import { computed, ref } from "vue";
import { Icon } from "@iconify/vue";
import { ABOUT_ME_DATA, CONTENT, EXPERIENCES_DATA } from "../constants";
import { useLanguage } from "../composables/useLanguage";
import SkillsModal from "./SkillsModal.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AboutMe',
    setup(__props) {
        const { language } = useLanguage();
        const text = computed(() => CONTENT[language.value]);
        const aboutData = computed(() => ABOUT_ME_DATA[language.value]);
        const experiences = computed(() => EXPERIENCES_DATA[language.value]);
        const skillsModalOpen = ref(false);
        const selectedStudy = ref(null);
        const openSkills = (edu) => {
            selectedStudy.value = edu;
            skillsModalOpen.value = true;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(text.value.sections.about), 1 /* TEXT */),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-[1px] flex-grow bg-black/10 dark:bg-white/10 ml-8 hidden md:block" }, null, -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createCommentVNode(" Education "),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(Icon), {
                                icon: "mdi:school",
                                class: "w-5 h-5 text-accent"
                            }),
                            _createElementVNode("h4", _hoisted_6, _toDisplayString(text.value.aboutMe.education), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutData.value.education, (edu, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    role: "button",
                                    tabindex: "0",
                                    onClick: ($event) => (openSkills(edu)),
                                    onKeydown: [
                                        _withKeys(_withModifiers(($event) => (openSkills(edu)), ["prevent"]), ["enter"]),
                                        _withKeys(_withModifiers(($event) => (openSkills(edu)), ["prevent"]), ["space"])
                                    ],
                                    class: _normalizeClass(["group border-l-2 pl-6 transition-colors duration-300 cursor-pointer focus:outline-none",
                                        edu.status === 'in_progress'
                                            ? 'border-accent'
                                            : 'border-accent/30 hover:border-accent'
                                    ])
                                }, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("span", _hoisted_10, _toDisplayString(edu.period), 1 /* TEXT */),
                                        (edu.status === 'in_progress')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(text.value.aboutMe.inProgress), 1 /* TEXT */))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(text.value.aboutMe.finished), 1 /* TEXT */))
                                    ]),
                                    _createElementVNode("h5", _hoisted_13, _toDisplayString(edu.program), 1 /* TEXT */),
                                    _createElementVNode("p", _hoisted_14, _toDisplayString(edu.faculty), 1 /* TEXT */),
                                    (edu.university)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(edu.university), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Open-skills affordance "),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_unref(Icon), {
                                            icon: "ph:list-bullets-bold",
                                            class: "w-3.5 h-3.5"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(text.value.nav.skills), 1 /* TEXT */),
                                        _createVNode(_unref(Icon), {
                                            icon: "ph:arrow-right-bold",
                                            class: "w-3 h-3 transition-transform duration-300 group-hover:translate-x-0.5"
                                        })
                                    ])
                                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_8));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]),
                    _createCommentVNode(" Certifications "),
                    (aboutData.value.certifications &&
                        aboutData.value.certifications.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _createVNode(_unref(Icon), {
                                    icon: "mdi:certificate",
                                    class: "w-5 h-5 text-accent"
                                }),
                                _createElementVNode("h4", _hoisted_19, _toDisplayString(text.value.aboutMe.certifications), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutData.value.certifications, (cert, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "border-l-2 border-accent/30 pl-6 hover:border-accent transition-colors duration-300"
                                    }, [
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(cert.year), 1 /* TEXT */),
                                        _createElementVNode("h5", _hoisted_22, _toDisplayString(cert.name), 1 /* TEXT */),
                                        _createElementVNode("p", _hoisted_23, _toDisplayString(cert.issuer), 1 /* TEXT */)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Languages & Interests "),
                    _createElementVNode("div", _hoisted_24, [
                        _createCommentVNode(" Languages "),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_25, [
                                _createVNode(_unref(Icon), {
                                    icon: "mdi:translate",
                                    class: "w-5 h-5 text-accent"
                                }),
                                _createElementVNode("h4", _hoisted_26, _toDisplayString(text.value.aboutMe.languages), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutData.value.languages, (lang, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "flex items-center justify-between border-b border-black/5 dark:border-white/5 pb-3"
                                    }, [
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(lang.name), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(lang.level), 1 /* TEXT */)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]),
                        _createCommentVNode(" Interests "),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_30, [
                                _createVNode(_unref(Icon), {
                                    icon: "mdi:heart",
                                    class: "w-5 h-5 text-accent"
                                }),
                                _createElementVNode("h4", _hoisted_31, _toDisplayString(text.value.aboutMe.interests), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutData.value.interests, (interest, index) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                        key: index,
                                        class: "px-4 py-2 bg-gray-100 dark:bg-white/10 text-sm font-medium uppercase tracking-wide"
                                    }, _toDisplayString(interest), 1 /* TEXT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ])
                    ])
                ]),
                _createCommentVNode(" Work Experience "),
                _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                        _createVNode(_unref(Icon), {
                            icon: "mdi:briefcase",
                            class: "w-5 h-5 text-accent"
                        }),
                        _createElementVNode("h4", _hoisted_35, _toDisplayString(text.value.aboutMe.experience), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experiences.value, (exp, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 border-b border-black/10 dark:border-white/10 hover:bg-white dark:hover:bg-white/5 transition-all duration-300 px-4 -mx-4"
                            }, [
                                _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("span", _hoisted_38, _toDisplayString(exp.period), 1 /* TEXT */),
                                    _createElementVNode("h5", _hoisted_39, _toDisplayString(exp.company), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(exp.role), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("p", _hoisted_43, _toDisplayString(exp.description), 1 /* TEXT */)
                                ])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _createCommentVNode(" Skills modal opened from a study card "),
                _createVNode(SkillsModal, {
                    open: skillsModalOpen.value,
                    study: selectedStudy.value?.program,
                    skills: selectedStudy.value?.skills ?? [],
                    onClose: _cache[0] || (_cache[0] = ($event) => (skillsModalOpen.value = false))
                }, null, 8 /* PROPS */, ["open", "study", "skills"])
            ]));
        };
    }
});
